/**
 * PDFViewerPanelNoPDFView Component - Message when saved message has no PDF
 *
 * Extracted from PDFViewerPanel.tsx
 */

import React from 'react';
import { MessageSquare } from 'lucide-react';
import type { Theme } from '../../themes/theme';

interface PDFViewerPanelNoPDFViewProps {
  theme: Theme;
}

export const PDFViewerPanelNoPDFView: React.FC<PDFViewerPanelNoPDFViewProps> = ({ theme }) => {
  return (
    <div className={`h-full flex items-center justify-center ${theme.colors.bg.secondary}`}>
      <div className="text-center px-6 space-y-3">
        <MessageSquare size={42} className={`mx-auto ${theme.colors.text.secondary}`} />
        <h4 className={`text-lg font-semibold ${theme.colors.text.primary}`}>Mensaje guardado</h4>
        <p className={`text-sm ${theme.colors.text.secondary}`}>
          Este mensaje no tiene un PDF asociado. Revisa el contenido en el panel superior.
        </p>
      </div>
    </div>
  );
};
